module.exports = __webpack_public_path__ + "img/logo@2x.2c8fd76d.png";